import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment"

export default {
    namespaced: true,
    state: {
        lstOf1: [],
        lstOf2: [],
        lstOfx: [],
        of1: {},
        of2: {},
        ofx: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null,
        print: true,
        relatsPath: "",
        sinceDate: moment().format("YYYY-MM-DD 00:00"),
		untilDate: moment().format("YYYY-MM-DD 23:59"),
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getOf1(state) {
            let of1 = { ...state.of1 }
            of1.of1geracao = of1.of1geracao ? of1.of1geracao : new Date(1900, 1, 1)
            of1.lstOf2 = state.lstOf2
            of1.lstOfx = state.lstOfx
            return of1
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, of1) {
			state.of1 = of1
            if (of1)
                state.update = true
		},
        initForm(state) {
            state.insert = false
            state.update = false
            state.of1 = {}
        },
        setParamsDataTable(state, payload) {
            state.lstOf1 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setOf1(state, of1) {
            state.of1 = of1
        },
        setLstOf1(state, lstOf1) {
            state.lstOf1 = lstOf1
        },
        setLstOf2(state, lstOf2) {
            state.lstOf2 = lstOf2
        },
        setLstOfx(state, lstOfx) {
            state.lstOfx = lstOfx
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, of1ordem) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Oryxplace/ProductionOrder/Find/${of1ordem}`)
                .then(response => {
                    let of1 = Utils.ValidateAxiosResponse(response.data);
                    commit("set", of1)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async get({ dispatch }, of1ordem) {
            return await this._vm.$axios.get(`/Oryxplace/ProductionOrder/Find/${of1ordem}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return null
            });
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/OryxPlace/ProductionOrder/Insert", getters.getOf1)
                .then(response => {
                    let of1 = Utils.ValidateAxiosResponse(response.data)
                    commit('setLastUpdatedRegister', of1);
                    commit('set', of1)
                    return of1
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Oryxplace/ProductionOrder/Update", getters.getOf1)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Oryxplace/ProductionOrder/Delete/${getters.getOf1.of1ordem}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/ordens-de-producao")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findProductList({ commit, dispatch }, of1ordem) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/ProductionOrder/FindProductList/${of1ordem}`, )
                .then(response => {
                    let lstOf2 = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstOf2", lstOf2)
                }).catch(error => {
                    commit("setLstOf2", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async findComponentList({ commit, dispatch, state }, of1ordem) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/ProductionOrder/FindComponentList/${of1ordem}`, )
                .then(async response => {
                    let lstOfx = Utils.ValidateAxiosResponse(response.data);

                    const promises = state.lstOf2.map(element => {
                        return dispatch("findComponentByProduct", {
                            of2produto: element.of2produto,
                            of2qtde: element.of2qtde
                        });
                    });

                    const componentsList = (await Promise.all(promises)).flat();

                    const totalComponentQuantities = componentsList.reduce((acc, componente) => {
                        const key = componente.ofxproduto
                        if (!acc[key])
                            acc[key] = 0
                        acc[key] += componente.ofxqtde
                        return acc
                    }, {})


                    lstOfx.forEach(ofx => {
                        const calculatedTotal = totalComponentQuantities[ofx.ofxproduto] || 0
                        if (ofx.ofxqtde !== calculatedTotal) {
                        ofx.untied = true
                        ofx.untiedQuantity = ofx.ofxqtde - calculatedTotal
                    }
                })

                commit("setLstOfx", lstOfx)
                }).catch(error => {
                    commit("setLstOfx", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")

            let url = `/Oryxplace/ProductionOrder/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`

            if (state.sinceDate) {
				url += `&sinceDate=${state.sinceDate}`
			}
			if (state.untilDate) {
				url += `&untilDate=${state.untilDate}`
			}
            let payload = await this._vm.$axios
				.get(url)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstOf1", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },

        async findRecipByProduct({ state, dispatch }, of2produto) {
            return await this._vm.$axios.get(`/OryxPlace/ProductionOrder/findRecipByProduct/${of2produto}`)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                state.of2 = { of2recip: payload.of2recip, of2produto: payload.of2produto, in1nome: payload.in1nome }
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: "Produto não encontrado"
				}, { root: true })
				return null
            });
        },

        async validateRecip({ state, dispatch }) {
            return await this._vm.$axios.get(`/OryxPlace/ProductionOrder/validateRecip/${state.of2.of2recip}/${state.of2.of2produto}`)
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: "Cilindro inexistente ou não correspondente ao produto"
				}, { root: true })
                state.of2.of2recip = ''
				return null
            });
        },

        async emitFiscalDocument(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Emitindo documento fiscal" , indeterminate: true }, {root: true})
            let payload = await this._vm.$axios.post(`/OryxPlace/ProductionOrder/EmitFiscalDocument/${store.getters.getOf1.of1ordem}`)
            .then(response => {
                Utils.ValidateAxiosResponse(response.data);
                return true
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            });
            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
		},

        //função para estorno inutilizada por hora
        async cancel(store, of1ordem){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Estornando OF", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/OryxPlace/ProductionOrder/Cancel", of1ordem)
			.then(() => {
				store.dispatch("parameters/openDialog", {
					titleText: "Ordem Estornada",
					titleColor: "green",
				}, { root: true })

			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message,
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},

        async print({ dispatch, state }, of1ordem ){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: `Imprimindo ordem ${of1ordem}` , indeterminate: true }, {root: true})
			await this._vm.$axios.post(`/OryxPlace/ProductionOrder/Print/${of1ordem}`)
			.then(response => {
				state.relatsPath = Utils.ValidateAxiosResponse(response.data);

				if(state.relatsPath && state.relatsPath.length > 0){
					dispatch("print/openRelatsPath", state.relatsPath, { root: true })
				}

				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return true
		},

        async printCylinderFilling(store, params){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Oryxplace/ProductionOrder/PrintCylinderFilling", params)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async cylinderFilterWithLinkedContent({ dispatch }, { text }) {
			return await this._vm.$axios.get(`/Oryxplace/ProductionOrder/CylinderFilterWithLinkedContent?&text=${text}`)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},
        async recipientFilterWithLinkedContent({ state, dispatch }) {
			return await this._vm.$axios.get(`/Oryxplace/ProductionOrder/RecipientFilterWithLinkedContent?of2produto=${state.of2.of2produto}`)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},
        async componentFilter({ dispatch }, { text }) {
			return await this._vm.$axios.get(`/Oryxplace/ProductionOrder/ComponentFilter?&text=${text}`)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},
        async findComponent({ state, dispatch }, ofxproduto) {
            return await this._vm.$axios.get(`/OryxPlace/ProductionOrder/FindComponent/${ofxproduto}`)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                state.ofx = { ofxproduto: payload.ofxproduto, in1nome: payload.in1nome, untied: true, untiedQuantity: payload.ofxqtde }
                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: "Produto não encontrado"
				}, { root: true })
				return null
            });
        },
        async modifyComponentByProduct({ state, dispatch }, { of2produto, of2qtde, isDelete = false }) {
            return await this._vm.$axios.get(`/OryxPlace/ProductionOrder/ModifyComponentByProduct/${of2produto}/${of2qtde}`)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);

                for (let index = 0; index < payload.length; index++) {
                    const itemIndex = state.lstOfx.findIndex(item => item.ofxproduto === payload[index].ofxproduto)
                    if(itemIndex !== -1) {
                        if (!isDelete)
                            state.lstOfx[itemIndex].ofxqtde += payload[index].ofxqtde;
                        else {
                            if((state.lstOfx[itemIndex].ofxqtde - payload[index].ofxqtde) > 0)
                                state.lstOfx[itemIndex].ofxqtde -= payload[index].ofxqtde;
                            else
                                state.lstOfx.splice(itemIndex, 1)
                        }
                    }
                    else {
                        state.lstOfx.push(payload[index])
                    }
                }

                return true
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: "Produto não encontrado"
				}, { root: true })
				return null
            });
        },
        async findComponentByProduct({ state, dispatch }, { of2produto, of2qtde }) {
            return await this._vm.$axios.get(`/OryxPlace/ProductionOrder/ModifyComponentByProduct/${of2produto}/${of2qtde}`)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                return payload
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: "Produto não encontrado"
				}, { root: true })
				return null
            });
        },
        async findAllowedUsers({ dispatch }, { text, dc0arquivo }) {
			return await this._vm.$axios.get(`/Oryxplace/ProductionOrder/FindAllowedUsers?&text=${text}&dc0arquivo=${dc0arquivo}`)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},
        async findAllMebopercom({ commit, dispatch }) {
			commit("setLoading", true)
			commit("initForm")
			return await this._vm.$axios
				.get("/Oryxplace/CylinderMovement/FindAllMebopercom")
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
                    return payload
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
                    return false
				})
		},
    }
}
